/**
 * 城市相关接口
 * 对应 Home端 - 地区接口
 */

import { http } from "@/http/axios";

// ==================== 类型定义 ====================

/** 城市项 */
export interface CityItem {
  city_id: number;
  name: string;
  merger_name: string;
  lng: number;
  lat: number;
}

// ==================== 接口请求 ====================

/**
 * 获取省份列表
 * GET /home/city/all_city
 * 公开接口，无需认证
 */
export function getAllCity() {
  return http.get<{ code: number; message: string; data: CityItem[] }>(
    "/home/city/all_city"
  );
}
